import servicesLogin from './servicesLogin';
import servicesLoginRecover from './servicesLoginRecover';
import servicesBeneficiario from './servicesBeneficiario';
import servicesAws from './servicesAws';
import servicesGcp from './servicesGcp';
import servicesProcedimento from './servicesProcedimento';
import servicesPatient from './servicesPatient';
import servicesME from './servicesME';

class Services {
  mobileengine = (route, params) => servicesME[route](params);

  login = (route, params) => servicesLogin[route](params);

  recoverPsw = (route, params) => servicesLoginRecover[route](params);

  procedimento = (route, params) => servicesProcedimento[route](params);

  procedimento_ME = (route, params) => servicesProcedimento[route](params);

  patient_ME = (route, params) => servicesPatient[route](params);

  beneficiario = (route, params) => servicesBeneficiario[route](params);

  beneficiario_ME = (route, params) => servicesBeneficiario[route](params);

  aws = (route, params) => servicesAws[route](params);

  gcp = (route, params) => servicesGcp[route](params);
}

export default new Services();
